import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Shipping.css';

function Shipping() {
  return (
    <Container className="shipping-page py-5">
      <h1 className="text-center mb-5">Kargo ve Teslimat Bilgileri</h1>
      
      <Row className="g-4">
        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Kargo Süreci</Card.Title>
              <Card.Text>
                <ul className="shipping-list">
                  <li>Siparişleriniz, ödeme onayından sonra 1-2 iş günü içerisinde hazırlanır.</li>
                  <li>Özel tasarım ürünleriniz için üretim süresi 2-3 iş günüdür.</li>
                  <li>Kargo teslimat süresi ortalama 2-4 iş günüdür.</li>
                  <li>Kargo takip numaranız, ürün kargoya verildiğinde SMS ve e-posta yoluyla tarafınıza iletilir.</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Kargo Firmaları</Card.Title>
              <Card.Text>
                <p>Anlaşmalı olduğumuz kargo firmaları:</p>
                <ul className="shipping-list">
                  <li>HEPSI JET</li>
                  <li>ARAS KARGO</li>
                  <li>PTT Kargo</li>
                </ul>
                <p>Siparişleriniz, belirtilen kargo firmalarından biri ile gönderilecektir.</p>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Teslimat Bilgileri</Card.Title>
              <Card.Text>
                <ul className="shipping-list">
                  <li>Teslimatlar sadece Türkiye içerisine yapılmaktadır.</li>
                  <li>Kargo teslimatları hafta içi 09:00-18:00 saatleri arasında yapılır.</li>
                  <li>Teslimat adresi değişikliği için müşteri hizmetlerimizle iletişime geçebilirsiniz.</li>
                  <li>Kargo teslimi sırasında ürünü kontrol etme hakkına sahipsiniz.</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Önemli Bilgiler</Card.Title>
              <Card.Text>
                <ul className="shipping-list">
                  <li>Kargo ücreti tüm siparişlerinizde ücretsizdir.</li>
                  <li>Hasarlı veya yanlış gönderilen ürünler için iade/değişim ücreti firmamıza aittir.</li>
                  <li>Teslimat sırasında kimlik gösterilmesi zorunludur.</li>
                  <li>Kargo firması, adresinize 3 kez teslimat denemesi yapar.</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="contact-info mt-5">
        <h4 className="text-center">Kargo Takibi ve Sorularınız İçin</h4>
        <p className="text-center">
          Müşteri hizmetlerimiz: +90 535 873 46 92<br />
          E-posta: mr.browncases@gmail.com
        </p>
      </div>
    </Container>
  );
}

export default Shipping; 